export enum DialogTypes {
    Open_Confirm_Dialog = '[DIALOG] Open_Confirm_Dialog',
    Open_Induction_Dialog = '[DIALOG] Open_Induction_Dialog',

    Set_Is_Dialog_Opening = '[DIALOG] Set_Is_Dialog_Opening',
    Set_Is_Dialog_Confirm = '[DIALOG] Set_Is_Dialog_Confirm',
    Set_Is_Dialog_Fetching = '[DIALOG] Set_Is_Dialog_Fetching',

    Show_Error_Notification_Dialog = 'SHOW_ERROR_NOTIFICATION',
    Show_Success_Notification_Dialog = 'SHOW_SUCCESS_NOTIFICATION',

    SHOW_LEAVE_ERROR_NOTIFICATION = 'SHOW_LEAVE_ERROR_NOTIFICATION',

    Close_Dialog = 'Close_Dialog',
    Close_All_Dialog = 'Close_All_Dialog',
}
